module.exports = __webpack_public_path__ + "static/media/visal-sm-logo.b17d81a7.png";